import icon from 'vue-svgicon';

icon.register({
    'regular/monitor-play': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15 23.253H9l.75-4.5h4.5l.75 4.5zM6.75 23.253h10.5"/><rect pid="1" x=".75" y=".753" width="22.5" height="18" rx="3" ry="3" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path pid="2" d="M8.25 12.929V6.578a.75.75 0 0 1 1.136-.643l5.292 3.175a.75.75 0 0 1 0 1.287l-5.292 3.175a.75.75 0 0 1-1.136-.643z" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
